/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoteStartTransactionCommand } from '../../models/remote-start-transaction-command';

export interface ApiOcppOperationRemoteStartTransactionPost$Params {
  chargerId?: string;
      body?: RemoteStartTransactionCommand
}

export function apiOcppOperationRemoteStartTransactionPost(http: HttpClient, rootUrl: string, params?: ApiOcppOperationRemoteStartTransactionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiOcppOperationRemoteStartTransactionPost.PATH, 'post');
  if (params) {
    rb.query('chargerId', params.chargerId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiOcppOperationRemoteStartTransactionPost.PATH = '/api/OcppOperation/remoteStartTransaction';
